"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRendererFactory = void 0;
const consts_1 = require("@opsbase/lib-time/consts");
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const get_1 = __importDefault(require("lodash/get"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importDefault(require("react"));
const DateRendererFactory = (viewField) => (item) => {
    const value = (0, get_1.default)(item, viewField.propertyName);
    const timezone = (0, get_1.default)(item, 'place.timezone');
    if (!value)
        return null;
    let m = timezone ? (0, moment_timezone_1.default)(value).tz(timezone) : (0, moment_timezone_1.default)(value);
    return (react_1.default.createElement(Horizontal_1.default, null,
        react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Text_1.default, null, m.format(consts_1.TinyDateFormat)),
            react_1.default.createElement(Text_1.default, { variant: "small", color: "lightgrey" }, m.format('YYYY - ddd'))),
        react_1.default.createElement(Text_1.default, { variant: "small" }, m.format(consts_1.SimpleTimeFormat))));
};
exports.DateRendererFactory = DateRendererFactory;
exports.default = exports.DateRendererFactory;
